import {
  collection,
  documentId,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  Timestamp,
} from "firebase/firestore";
import { db } from "src/firebase";
import {
  IntegrationHealthCursor,
  IntegrationHealthException,
  IntegrationHealthPage,
} from "./types/integration-health.entity";

const PAGE_SIZE = 20;
const SOURCE_BATCH_SIZE = PAGE_SIZE + 1;

class IntegrationHealthRepository {
  private makeCursor(offset?: IntegrationHealthCursor) {
    if (!offset) return undefined;

    return new Timestamp(
      offset.lastFailedAtSeconds,
      offset.lastFailedAtNanoseconds,
    );
  }

  async find(offset?: IntegrationHealthCursor): Promise<IntegrationHealthPage> {
    const cursor = this.makeCursor(offset);
    const snapshot = await getDocs(
      query(
        collection(db, "integration_health_exceptions"),
        orderBy("lastFailedAt", "desc"),
        orderBy(documentId(), "desc"),
        ...(cursor && offset ? [startAfter(cursor, offset.id)] : []),
        limit(SOURCE_BATCH_SIZE),
      ),
    );
    const exceptionDocs = snapshot.docs.slice(0, PAGE_SIZE);
    const lastExceptionDoc = exceptionDocs[exceptionDocs.length - 1];
    const lastFailedAt = lastExceptionDoc?.data().lastFailedAt as
      | Timestamp
      | undefined;

    return {
      items: exceptionDocs.map((exceptionDoc) => ({
        id: exceptionDoc.id,
        ...(exceptionDoc.data() as Omit<IntegrationHealthException, "id">),
      })),
      nextOffset:
        snapshot.size > PAGE_SIZE && lastExceptionDoc && lastFailedAt
          ? {
              id: lastExceptionDoc.id,
              lastFailedAtSeconds: lastFailedAt.seconds,
              lastFailedAtNanoseconds: lastFailedAt.nanoseconds,
            }
          : undefined,
    };
  }
}

export const integrationHealthRepository = new IntegrationHealthRepository();
